import styled, { css } from 'styled-components';

export const StyledWrapperFields = styled.div`
  position: relative;
  margin-top: 14px;
  margin-bottom: 20px;
   
  input[type="text"] {
    background: transparent;
  }
`;

export const StyledLabel = styled.label`
  display: flex;
  flex-direction: column;
  font-size: 16px;

  & + & {
    margin-top: 12px;
  }

  &:nth-child(2n + 1):not(:first-child) {
    margin-top: 20px;
  }
`;

export const StyledInput = styled.input`${(props) => (
  css`
    display: inline-block;
    width: 100%;
    height: 36px;
    box-sizing: border-box;
    font-weight: 600;
    padding: 0;
    text-align: center;
    border: 1px solid ${props.borderColor};
    border-radius: 4px;
    margin-top: 6px;
  `
)}`;

export const StyledGlobalWrapper = styled.div`${
  (props) => {
    const { styles } = props;
    const {
      color,
      inputsLabelsTextAlign,
      inputsBorderRadius,
      calendarBorderRadius,
      calendarCellsBorderRadius,
      buttonsBorderRadius,
    } = styles.body || {};
    const {
      padding: containerPadding,
      margin: containerMargin,
      widgetContainerBorderRadius,
    } = styles.container || {};

    return css`
      input, select, textarea {
        border-radius: ${inputsBorderRadius}px !important;
      }
      
      button {
        border-radius: ${buttonsBorderRadius}px !important;
      }  
      
      .rdp-head {
        .rdp-head_row {
          border-radius: ${calendarBorderRadius}px;
        }
      }
      
      .rdp-cell {
        button.rdp-button {
          border-radius: ${calendarCellsBorderRadius}px !important;
        }
      }

      .styled-select {
        .bta-react-select__control {
          border-radius: ${inputsBorderRadius}px;
        }
        span[class$="indicatorSeparator"] {
          background-color: ${color};
        }
        svg[class$="Svg"] {
          color: ${color};
        }
      }
      .locations-select, .resources-select, .variant-select {
        .titles {
          display: inline-block;
          width: 100%;
          text-align: ${inputsLabelsTextAlign};
        }
      }
      .rental-widget-label {
        text-align: ${inputsLabelsTextAlign};
          
        .timeslots-select {
          text-align: left;
        }
      }  
      .sub-panel {
        border-radius: ${widgetContainerBorderRadius}px;
        padding: ${containerPadding}px;
        margin: ${containerMargin}px;  
      }
    `;
  }
}`;
